import AEOImage from "../../../../src/resources/images/aeo.jpg";
import CenterDiv from "../../../style/styled-components/components/CenterDiv";
import ContactPoints from "../../../components/ui/members/ContactPoints";
import DiamondScope from "../../../components/ui/specialty/DiamondScope";
import UseBreakpoints from "../../../components/hooks/ui/UseBreakpoints";
import { card, navyCard } from "../../../style/styled-components/mixins";
import PageTemplate from "../../../components/ui/common/template/PageTemplate";
import TitleTemplate from "../../../components/ui/common/template/TitleTemplate";
import WorkScopes from "../../../components/ui/specialty/WorkScopes";
import img1 from "../../../resources/images/icon/8. AEO/1. AEO 신규인증.png";
import img2 from "../../../resources/images/icon/8. AEO/2. AEO사후관리.png";
import img3 from "../../../resources/images/icon/8. AEO/3. AEO 정기자체평가 관리.png";
import img4 from "../../../resources/images/icon/8. AEO/4. AEO 평가 대응서비스.png";
import img5 from "../../../resources/images/icon/8. AEO/5. AEO 종합심사대응.png";
import styled from "styled-components";

// 근거: 기존 aeoprocess.png 플로우차트. 내용은 그대로 두고 이미지 대신 코드로 그려 사이트 톤에 맞춘다.
const processSteps = [
  { step: "01", title: "준비", note: "일반적으로 3~5개월 소요" },
  { step: "02", title: "공인신청", org: "관세청 UNI-PASS" },
  { step: "03", title: "서류심사", org: "AEO진흥협회", note: "공인신청 접수일로부터 2개월 이내 심사" },
  { step: "04", title: "보완요구", note: "서류보완통보일로부터 1개월 이내 제출(서류심사기간에 불산입)", warn: "미충족 시 반려·기각, 공인신청부터 다시 진행" },
  { step: "05", title: "현장심사", org: "관세청", note: "신청한 문서화와 실행화의 일치 여부 확인", warn: "불일치 시 기각" },
  { step: "06", title: "AEO 심의위원회", note: "심의 결과에 따라 공인·유보·기각 결정" },
];
const processResults = [
  { title: "AEO 공인", featured: true },
  { title: "유보", text: "개선계획에 따라 보완 가능 시" },
  { title: "기각", text: "공인기준 충족이 불가능 시" },
];

const AEOPage = () => {
  const breakpoints = UseBreakpoints();
  return (
    <PageTemplate
      large
      image={AEOImage}
      title="AEO 인증"
      phrase="AEO의 시작과 성장 및 발전을 함께해 온 에이원만의 Know-How를 제공합니다."
      description="국내의 수출입 기업 및 포워딩, 운영인 등 수출입 공급망의 기업을 대상으로
      AEO 인증 획득, 사후관리, 정기자체평가서 평가 및 제출 지원, AEO
      인증기업의 종합심사 대응, 정기 수입세액정산제도에 따른 심사와 보고서
      작성 및 기획/법인심사 대리, 사전 Audit, FTA(원산지 검증, 서류 발급) 등
      관세업무에서 발생할 수 있는 모든 업무에 대한 서비스를 제공합니다.
      해당 업무에는 관세사 및 관세 전문가를 전담으로 배정하여 기업의
      환경에 따라 제공하는 맞춤형 서비스를 제공합니다."
    >
      <TitleTemplate
        title="AEO 인증절차"
        noImage
        subHeader="AEO 인증부터 종합심사까지 필요한 모든 업무에 대한 서비스를 제공합니다."
      />
      <ProcessSteps breakpoints={breakpoints}>
        {processSteps.map((s) => (
          <div key={s.step}>
            <span className="step">{s.step}</span>
            <b>{s.title}</b>
            {s.org && <span className="org">{s.org}</span>}
            {s.note && <p>{s.note}</p>}
            {s.warn && <p className="warn">{s.warn}</p>}
          </div>
        ))}
      </ProcessSteps>
      <ProcessResults breakpoints={breakpoints}>
        <div className="label">심의 결과</div>
        {processResults.map((r) => (
          <div key={r.title} className={r.featured ? "featured" : undefined}>
            <b>{r.title}</b>
            {r.text && <span>{r.text}</span>}
          </div>
        ))}
      </ProcessResults>
      <TitleTemplate title="AEO 인증 혜택" noImage />
      <CenterDiv>
        <AEOBenefitTable>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2}>특례기준</th>
              <th colSpan={3}>AEO 등급</th>
              <th rowSpan={2}>비고</th>
            </tr>
            <tr>
              <th>A</th>
              <th>AA</th>
              <th>AAA</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>행정형벌보다 과태료 등 행정질서벌 우선 고려</td>
              <td>○</td>
              <td>○</td>
              <td>○</td>
              <td>AM정보제공</td>
            </tr>
            <tr>
              <td>과태료 경감</td>
              <td>20%</td>
              <td>30%</td>
              <td>50%</td>
              <td></td>
            </tr>
            <tr>
              <td>통고처분 금액의 경감</td>
              <td>15%</td>
              <td>30%</td>
              <td>50%</td>
              <td></td>
            </tr>
            <tr>
              <td>기업 ERP에 의한 수출입 및 화물신고</td>
              <td>○</td>
              <td>○</td>
              <td>○</td>
              <td></td>
            </tr>
            <tr>
              <td>신고오류로 인한 제재 감경</td>
              <td>30%</td>
              <td>50%</td>
              <td>70%</td>
              <td>PL정지 등</td>
            </tr>
            <tr>
              <td>AM에 의한 수출입신고 정정, 오류점수 미부과</td>
              <td>○</td>
              <td>○</td>
              <td>○</td>
              <td></td>
            </tr>
            <tr>
              <td>
                국제공항 입출국 시 전용검사대 이용
                <br />
                국제공항 출국 시 승무원 전용통로 이용
              </td>
              <td>○</td>
              <td>○</td>
              <td>○</td>
              <td>
                A/AA: 대표자
                <br />
                AAA: 대표자, 총괄책임자
              </td>
            </tr>
          </tbody>
        </AEOBenefitTable>
      </CenterDiv>
      <TitleTemplate
        title="업무 범위"
        noImage
        subHeader="각 인증 부문별 고객사에 해당하는 맞춤형 서비스를 제공합니다."
      />
      <WorkScopes
        contents={[
          { title: "AEO 신규인증", icon: img1 },
          { title: "AEO 사후관리", icon: img2 },
          { title: "AEO 정기자체평가 관리", icon: img3 },
          { title: "AEO 평가 대응 서비스", icon: img4 },
          { title: "AEO 종합심사대응", icon: img5 },
        ]}
      />
      <TitleTemplate
        title="Strength"
        noImage
        subHeader="A-One만의 장점으로 고객을 힘껏 서포트해 나가겠습니다."
      />
      <DiamondScope
        contents={[
          {
            title: "ONE-STOP SERVICE",
            text: "신규인증부터 재인증까지 책임 서비스 ",
          },
          {
            title: "TASK-FORCE",
            text: "국내 최고 AEO 전문 전담팀 구성으로 전문성 확보",
          },
          {
            title: "Management",
            text: "사후관리를 통한 AEO 재인증 심사 대비",
          },
          {
            title: "Consulting",
            text: "전문 컨설턴트가 기업을 직접 방문하여 AEO 인증관리",
          },
        ]}
      />
      <TitleTemplate
        title="Contact Point"
        noImage
        subHeader="언제나 믿고 맡길 수 있는 최고의 멤버와 함께합니다."
      />
      <ContactPoints members={["kht3073"]} />
    </PageTemplate>
  );
};
export default AEOPage;
const ProcessSteps = styled.div`
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.xl ? "repeat(6, minmax(0, 1fr))" : breakpoints.md ? "repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 1rem;
  & > div {
    ${card}
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 1.4rem 1.2rem 1.2rem;
    & > .step {
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.08em;
      color: ${({ theme }) => theme.colors.accent};
    }
    & > b {
      font-size: 1.05rem;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > .org {
      font-size: 0.8rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.accent};
    }
    & > p {
      margin: 0.2rem 0 0;
      font-size: 0.8rem;
      line-height: 1.55;
      color: ${({ theme }) => theme.colors.foreground.dimmed};
      &.warn {
        color: ${({ theme }) => theme.colors.caution};
      }
    }
  }
`;
const ProcessResults = styled.div`
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.md ? "auto repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 1rem;
  margin-top: 1rem;
  & > .label {
    display: flex;
    align-items: center;
    padding: 0 0.25rem;
    font-size: 0.9rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
  }
  & > div:not(.label) {
    ${card}
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.25rem;
    padding: 1.1rem 1.3rem;
    & > b {
      font-size: 1.05rem;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > span {
      font-size: 0.8rem;
      line-height: 1.55;
      color: ${({ theme }) => theme.colors.foreground.dimmed};
    }
    &.featured {
      ${navyCard}
      border: none;
      & > b {
        color: white;
      }
    }
  }
`;
const AEOBenefitTable = styled.table`
  width: 100%;
  max-width: 62rem;
  border-spacing: 0;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  & th,
  & td {
    padding: 0.9em 1.1em;
    text-align: center;
  }
  & > thead th {
    font-weight: 600;
    background-color: ${({ theme }) => theme.colors.dark};
    color: white;
  }
  & > thead tr:last-child th {
    border-top: 1px solid rgba(255, 255, 255, 0.18);
  }
  & > tbody {
    & td {
      font-size: 0.95em;
    }
    & > tr:nth-child(even) {
      background-color: ${({ theme }) => theme.colors.monotone.extralight};
    }
    & > tr + tr > td {
      border-top: 1px solid ${({ theme }) => theme.colors.line};
    }
    & td:first-child {
      text-align: left;
      color: ${({ theme }) => theme.colors.monotone.dark};
    }
  }
`;
